export default [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/auth-v2/Login.vue'),
    meta: {
      layout: 'full',
      resource: 'auth',
      redirectIfLoggedIn: true,
    },
  },
]
